var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiVideoGen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 800,
    height: 800,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 340,
    height: 220,
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 118,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 118,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 118,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 118,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 118,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 118,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 118,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 278,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 278,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 278,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 278,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 278,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 278,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 278,
    width: 30,
    height: 24,
    rx: 4,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170 175 L170 245 L240 210 Z",
    fill: "#ffffff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 420,
    r: 72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400 375 L400 465",
    stroke: "#ffffff",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355 420 L445 420",
    stroke: "#ffffff",
    strokeWidth: 14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiVideoGen);
export default __webpack_public_path__ + "static/media/aiVideoGen.524db74cb08aab46cfdf4811297765f1.svg";
export { ForwardRef as ReactComponent };